export default __webpack_public_path__ + "static/media/dock-mobile.4d13ee58.svg";